import { useFormik } from 'formik';
import { Colxx } from '../../../components/common/CustomBootstrap';
import { Box, Button, FormControl, FormHelperText, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import AutocompleteAsync from '../../../Components2/common/AutocompleteAsync';
import { useAuth0 } from '@auth0/auth0-react';
import { getAllCentersPaginateAsListUtil } from '../../../api/centerApi';

const AddEditUserForm = ({ validationSchema, initialValues, handleOnClose, mutateAsync, isPending }) => {
  const { getAccessTokenSilently } = useAuth0();
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      values.centers = values.centers.map((c) => c._id);
      await mutateAsync(values, {
        onSuccess: () => {
          handleOnClose();
        },
      });
    },
    enableReinitialize: true,
  });

  const getErrorText = (field) => {
    return formik.touched[field] && formik.errors[field] ? formik.errors[field] : '';
  };

  return (
    <form className="center-form" onSubmit={formik.handleSubmit}>
      <div className="center-row-md">
        <Colxx xl="5">
          <TextField
            id="name"
            name="name"
            label="Nombre"
            variant="outlined"
            required
            fullWidth
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={getErrorText('name')}
          />
        </Colxx>

        <Colxx xl="7">
          <TextField
            id="email"
            name="email"
            label="Email"
            variant="outlined"
            required
            fullWidth
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={getErrorText('email')}
          />
        </Colxx>
      </div>
      <div className="center-row-md">
        <Colxx xl="12">
          <FormControl variant="outlined" fullWidth error={formik.touched.centers && Boolean(formik.errors.centers)}>
            <Box sx={{ maxWidth: 500 }}>
              <AutocompleteAsync
                multiple
                queryFn={async (params) => {
                  const token = await getAccessTokenSilently();
                  return getAllCentersPaginateAsListUtil(token, params);
                }}
                queryKey={['centers-list-util']} // importante: estable para el cache
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                onChange={(value) => formik.setFieldValue('centers', value)}
                label="Centros"
                initialValue={formik.values.centers}
              />
            </Box>
            <FormHelperText>{getErrorText('centers')}</FormHelperText>
          </FormControl>
        </Colxx>
      </div>
      {/* <div className="center-row-md">
        <Colxx xl="12">
          <FormControl variant="outlined" fullWidth error={formik.touched.roles && Boolean(formik.errors.roles)}>
            <InputLabel id="role-label">Roles*</InputLabel>
            <Select
              labelId="roles-label"
              id="roles"
              name="roles"
              value={formik.values.roles}
              onChange={formik.handleChange}
              input={<OutlinedInput label="Roles*" />}
              multiple
              disabled
            >
              <MenuItem value="user">Usuario</MenuItem>
            </Select>
            <FormHelperText>{getErrorText('roles')}</FormHelperText>
          </FormControl>
        </Colxx>
      </div> */}

      <div className="button-group-tiendas">
        <Button
          type="submit"
          variant="contained"
          style={{ backgroundColor: '#3C4145' }}
          endIcon={<SendIcon />}
          disabled={isPending}
        >
          Confirmar
        </Button>
        <Button
          disabled={isPending}
          onClick={handleOnClose}
          type="button"
          variant="contained"
          color="error"
          endIcon={<CloseIcon />}
        >
          Cancelar
        </Button>
      </div>
    </form>
  );
};

export default AddEditUserForm;
